import "./callback.js";
import "./consultant.js";
import "./slider.js";
import "./conveyor";
import "./registrator";
import "./file";


// WEBPACK FOOTER //
// ./vue/bootstrap.js